import { jsx as t } from "react/jsx-runtime";
import { NotificationManager as a } from "./index.es83.js";
import { DynamicContainer as i } from "./index.es499.js";
import { Toast as n } from "./index.es84.js";
import { FlashMessage as r } from "./index.es87.js";
const p = () => {
  const o = a.getInstance();
  return /* @__PURE__ */ t(
    i,
    {
      manager: o,
      componentMap: {
        flashMessage: r,
        toast: n
      },
      removeItem: o.removeNotification
    }
  );
};
export {
  p as NotificationContainer
};
//# sourceMappingURL=index.es543.js.map
